
import dayjs from 'dayjs';
import util from './index';

export default {
	parse: function (value) {

		if (!value) {
			return null;
		}
		value = util
			.fixDates(value).toString();

		return new Date(Number(value.substr(0, 4)),
			Number(value.substr(4, 2)) - 1,
			Number(value.substr(6, 2)),
			Number(value.substr(8, 2)),
			Number(value.substr(10, 2)),
			Number(value.substr(12, 2))
		)
	},
	toString: function (date, format) {
		if (date === undefined || typeof date !== 'object' || date === null) {
			return '-';
		}
		let returnValue = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
		if (format === true) {
			returnValue += " - " + this.getFullTime(date);
		}
		return returnValue;
	},
	getMonthName: function (date) {
		let locale = "en-us";
		return (date.toLocaleString(locale, { month: "short" }));
	},
	formatAMPM: function (date) {
		if (date === undefined || typeof date !== 'object' || date === null) {
			return '';
		}
		let hours = date.getHours();
		let minutes = date.getMinutes();
		let ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		let strTime = hours + ':' + minutes + ' ' + ampm;
		return strTime;
	},
	getUtDateTime: function (date) {
		let dateToConvert = new Date();
		if (date) {
			dateToConvert = new Date(date);
		}
		return dateToConvert.toISOString().slice(0, 19).replace('T', ' ');
	},
	getLocalDateTime: function (utcDate) {
		if (!utcDate) {
			return;
		}
		let d = new Date(utcDate);
		let offset = new Date().getTimezoneOffset();
		d.setMinutes(d.getMinutes() - offset);
		return d;
	},
	getFullTime(date) {
		if (!date)
			return
		return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ":" + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ":" + (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	},
	getTimeDiff(firstDate, secondDate) {
		let timeStart = new Date(firstDate).getTime();
		let timeEnd = new Date(secondDate).getTime();
		let hourDiff = timeEnd - timeStart; //in ms
		let secDiff = hourDiff / 1000; //in s
		return (secDiff + " Secs");

	},
	formateSecond(totalSeconds) {
		if (!totalSeconds) {
			return "0s";
		}
		let month = Math.floor(totalSeconds / 2419200);
		totalSeconds %= 2419200;
		let week = Math.floor(totalSeconds / 604800);
		totalSeconds %= 604800;
		let day = Math.floor(totalSeconds / 86400);
		totalSeconds %= 86400;
		let hours = Math.floor(totalSeconds / 3600);
		totalSeconds %= 3600;
		let minutes = Math.floor(totalSeconds / 60);
		let seconds = totalSeconds % 60;
		return (
			(month ? month + 'mth ' : '') +
			(week ? week + 'w ' : '') +
			(day ? day + 'd ' : '') +
			(hours ? hours + 'h ' : '') +
			(minutes ? minutes + 'm ' : '') +
			(month !== 0 || week !== 0 || day !== 0 || hours !== 0 || minutes !== 0 ? (seconds ? seconds + 's' : '') : seconds + 's')
		)
	},
	dateParse(field, time) {
		let date = '';
		if (field) {
			if (typeof (field) === 'string') {
				field = util.$D(field);
			}
			date = dayjs(field).format('L') + ' ' + dayjs(field, 'm-D-YYYY HH:mm:ss').format("HH:mm a");
			return date;
		}
	}
}